import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { RegisteredAPIModel, RegisteredAPIRoute, RoutePermissionModel, UserPermissionModel } from './casl-state/casl-permissions.model';

@Injectable({
  providedIn: 'root'
})
export class CaslPermissionsService {
  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);

  getRoutePermissions() {
    return this._httpClient.get<RoutePermissionModel[]>(`${this._apiUrl}/v1/permissions/get-all-routes`);
  }

  getRolePermissions() {
    return this._httpClient.get<UserPermissionModel[]>(`${this._apiUrl}/v1/permissions/get-all`);
  }

  getRegisteredAPIModels() {
    return this._httpClient.get<RegisteredAPIModel[]>(`${this._apiUrl}/v1/registered-routes-models/get-registered-api-models`);
  }

  getRegisteredAPIRoutes() {
    return this._httpClient.get<RegisteredAPIRoute[]>(`${this._apiUrl}/v1/registered-routes-models/get-registered-api-routes`);
  }

  addRoutePermission(routePermission) {
    return this._httpClient.post<RoutePermissionModel>(`${this._apiUrl}/v1/permissions/create-route`, routePermission);
  }

  deleteRoutePermission(routePermission) {
    return this._httpClient.delete<RoutePermissionModel>(`${this._apiUrl}/v1/permissions/delete-route/${routePermission._id}`);
  }

  updateRoutePermission(routePermission, payload) {
    return this._httpClient.put<RoutePermissionModel>(`${this._apiUrl}/v1/permissions/update-route/${routePermission._id}/${routePermission.md5Checksum}`, payload);
  }
}
